(function (app, ng) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Home.Calendar",
            {
                url: "/Calendar",
                component: "calendar",
                redirectTo: "Home.Calendar.CalendarView"
            });
    }]);

    app.component("calendar",
        {
            templateUrl: "/App/Calendar/calendar-template.html",
            controller: calendarController,
            bindings: {
                currentUser: "<"
            }
        });

    function calendarController($rootScope, scheduledTaskApi, appointmentApi, $q, _, moment, marketingTrackerApi, marketingTrackerAuthService, marketingTrackerAccessGroupApi, externalTenantApi, marketingTrackerUserApi, userApi, marketingTrackerArcEventApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    isCalendarView: true
                },
                eventFilter: {
                    showScheduledTasks: true,
                    showAppointments: true,
                    showMarketingTrackerEvents: true,
                    hideCompleted: false
                },
                years: [],
                months: [],
                allScheduledTasks: [],
                allAppointments: [],
                allMarketingTrackerEvents: [],
                loadedDates: [],
                updateEventFilter: updateEventFilter,
                refreshCalendarData: refreshCalendarData,
                updateSelectedCalendarUsers: updateSelectedCalendarUsers,
                updateData: updateData
            });

        function updateEventFilter() {
            $ctrl.eventFilter = ng.copy($ctrl.eventFilter);
        }

        function getScheduledTasks(year, month) {
            return scheduledTaskApi.getUserScheduledTasks($ctrl.currentUser.Id, year, month).then(function (tasks) {
                return tasks;
            });
        }

        function getAppointments(year, month, nextPageToken) {
            return appointmentApi.getUserAppointments($ctrl.currentUser.Id, nextPageToken, year, month).then(function (appts) {
                if (!appts.NextPage) return appts;
                return getAppointments(year, month, appts.NextPage).then(function (recursiveAppts) {
                    return appts = _.unionBy(_.concat(appts, recursiveAppts), 'Id');
                });
            });
        }

        function getMarketingTrackerAccessGroupEvents(accessGroupId, year, month, nextPageToken) {
            return marketingTrackerAccessGroupApi.getEventsByDate(accessGroupId, year, month, nextPageToken)
                .then(function (events) {
                    if (!events.NextPage) return events;
                    return getMarketingTrackerAccessGroupEvents(accessGroupId, year, month, events.NextPage)
                        .then(function (recursiveEvents) {
                            return events = _.concat(events, recursiveEvents);
                        });
                });
        }

        function getMarketingTrackerAccessGroupAncillaryEvents(accessGroupId, year, month, nextPageToken) {
            return marketingTrackerAccessGroupApi.getAncillaryEventsByDate(accessGroupId, year, month, nextPageToken)
                .then(function (events) {
                    if (!events.NextPage) return events;
                    return getMarketingTrackerAccessGroupAncillaryEvents(accessGroupId, year, month, events.NextPage)
                        .then(function (recursiveEvents) {
                            return events = _.concat(events, recursiveEvents);
                        });
                });
        }

        function getMarketingTrackerEventsForAccessGroup(accessGroupId, year, month) {
            var p1 = getMarketingTrackerAccessGroupEvents(accessGroupId, year, month);
            var p2 = getMarketingTrackerAccessGroupAncillaryEvents(accessGroupId, year, month);
            return $q.all([p1, p2]).then(function (results) {
                var events = [];
                ng.forEach(results,
                    function (r) {
                        events = _.concat(events, r);
                    });
                return events;
            });
        }

        function getDataByDate(year, month) {
            var promises = [];

            var hasTasks = _.find($ctrl.allScheduledTasks,
                function (row) { return row.year === year && row.month === month; });
            var hasAppts = _.find($ctrl.allAppointments,
                function (row) { return row.year === year && row.month === month; });
            var hasEvents = _.find($ctrl.allMarketingTrackerEvents,
                function (row) { return row.year === year && row.month === month });

            if (!hasTasks)
                promises.push(getScheduledTasks(year, month + 1).then(function (tasks) {
                    return $ctrl.allScheduledTasks.push({
                        year: year,
                        month: month,
                        data: tasks
                    });
                }));

            if (!hasAppts)
                promises.push(getAppointments(year, month + 1).then(function (appts) {
                    $ctrl.allAppointments.push({
                        year: year,
                        month: month,
                        data: appts
                    });
                    return $ctrl.allAppointments
                }));

            if ($ctrl.marketingTrackerAccessGroupId && !hasEvents) {
                promises.push(
                    getMarketingTrackerEventsForAccessGroup($ctrl.marketingTrackerAccessGroupId, year, month + 1).then(
                        function (events) {
                            return $ctrl.allMarketingTrackerEvents.push({
                                year: year,
                                month: month,
                                data: events
                            });
                        }).catch(ng.noop));
            }
            return $q.all(promises);
        }

        function preLoadDates() {
            var curr = moment(new Date($ctrl.ui.year, $ctrl.ui.month, 1));

            if ($ctrl.ui.isCalendarView) {
                $ctrl.ui.calViewLoading = true;
                var prevClone = curr.clone().subtract(5, "months");
                var nextClone = curr.clone().add(5, "months");

                while (prevClone.month() !== curr.month()) {
                    var hasPrevDate = _.find($ctrl.loadedDates,
                        function (row) {
                            return row.year === prevClone.year() && row.month === prevClone.month();
                        });

                    var hasNextDate = _.find($ctrl.loadedDates,
                        function (row) {
                            return row.year === nextClone.year() && row.month === nextClone.month();
                        });

                    if (!hasPrevDate)
                        $ctrl.loadedDates.push({ year: prevClone.year(), month: prevClone.month(), isNew: true });
                    else hasPrevDate.isNew = false;

                    if (!hasNextDate)
                        $ctrl.loadedDates.push({ year: nextClone.year(), month: nextClone.month(), isNew: true });
                    else hasNextDate.isNew = false;

                    prevClone.add(1, "month");
                    nextClone.subtract(1, "month");
                }
            } else {
                $ctrl.ui.listViewLoading = true;
            }

            var hasCurrDate = _.find($ctrl.loadedDates,
                function (row) {
                    return row.year === curr.year() && row.month === curr.month();
                });

            if (!hasCurrDate)
                $ctrl.loadedDates.push({ year: curr.year(), month: curr.month(), isNew: true });
            else hasCurrDate.isNew = false;
        }

        function refreshCalendarData() {
            var promises = [];
            preLoadDates();

            var dates = _.filter($ctrl.loadedDates,
                function (row) {
                    return row.isNew;
                });

            ng.forEach(dates, function (row) {
                promises.push(getDataByDate(row.year, row.month));
            });

            var hasFigEvents = _.find($ctrl.allMarketingTrackerEvents, function (row) { return row.userId === "FIG"; });

            if (!hasFigEvents)
                promises.push(marketingTrackerArcEventApi.getArcEvents().catch(ng.noop).then(function (events) {
                    events = events || [];

                    ng.forEach(events,
                        function (event) {
                            var eventDate = new Date(event.EventDate);
                            var exists = _.find($ctrl.allMarketingTrackerEvents,
                                function (row) {
                                    return row.userId === "FIG" &&
                                        row.year === eventDate.getUTCFullYear() &&
                                        row.month === eventDate.getUTCMonth();
                                });
                            var newEvent = {
                                EventGroup: {},
                                Title: event.Title,
                                EventDate: event.EventDate,
                                EventType: {
                                    Name: "FIG Event",
                                    Id: "FIG Event"
                                }
                            };
                            if (exists) {
                                exists.data.push(newEvent);
                            } else {
                                $ctrl.allMarketingTrackerEvents.push({
                                    userId: "FIG",
                                    year: eventDate.getUTCFullYear(),
                                    month: eventDate.getUTCMonth(),
                                    data: [newEvent]
                                });
                            }
                        });
                }));

            $q.all(promises).then(function () {
                $ctrl.allScheduledTasks = ng.copy($ctrl.allScheduledTasks);
                $ctrl.allAppointments = ng.copy($ctrl.allAppointments);
                $ctrl.allMarketingTrackerEvents = ng.copy($ctrl.allMarketingTrackerEvents);
                $ctrl.ui.loading = false;
                $ctrl.ui.calViewLoading = false;
                $ctrl.ui.listViewLoading = false;
            }, function () {
                $ctrl.ui.loading = false;
                $ctrl.ui.calViewLoading = false;
                $ctrl.ui.listViewLoading = false;
            });
        }

        function updateData(start, end, today) {
            var previousMonth = moment(new Date($ctrl.ui.year, $ctrl.ui.month, 1)).add(-1, "month");
            var nextMonth = moment(new Date($ctrl.ui.year, $ctrl.ui.month, 1)).add(1, "month");
            $ctrl.ui.year = today.year();
            $ctrl.ui.month = today.month();
            if (start < previousMonth || end > nextMonth)
                $ctrl.refreshCalendarData();
        }

        function updateSelectedCalendarUsers() {

            $ctrl.ui.selectedUsers = $ctrl.users.filter(function (user) {
                return user.IsSelected;
            });
            var selectedUserIds = $ctrl.ui.selectedUsers.map(function (u) {
                return u.Id;
            });
            userApi.updateCalendarView($ctrl.currentUser.Id, selectedUserIds).then($ctrl.refreshCalendarData());
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.loading = true;
            $ctrl.ui.year = (new Date()).getFullYear();

            var year = 2015;
            while (year <= $ctrl.ui.year) {
                $ctrl.years.push(year);
                year++;
            }

            for (var i = 0; i < 12; i++) {
                $ctrl.months.push(moment().month(i).format("MMMM"));
                if (i === moment().month())
                    $ctrl.ui.month = i;
            }

            marketingTrackerApi.getToken($ctrl.currentUser.Id).then(token => {
                marketingTrackerAuthService.setAccessToken(token);
                externalTenantApi.getMarketingTrackerAccessGroup().catch(ng.noop).then(function (accessGroup) {
                    if (accessGroup)
                        $ctrl.marketingTrackerAccessGroupId = accessGroup.AccessGroupId;
                });
            }).catch(ng.noop).then(function () {

                userApi.getCalendarUsers().then(response => {

                    $ctrl.users = response;

                    $ctrl.ui.selectedUsers = response.filter(function (user) {
                        return user.IsSelected;
                    });

                    if ($ctrl.ui.selectedUsers.length === 0) {
                        $ctrl.users[0].IsSelected = true;
                        updateSelectedCalendarUsers();
                    }

                    else {
                        refreshCalendarData();
                    }
                });
            });
        }

        $rootScope.$on("scheduledTaskCreated",
            function (result, data) {
                var date = new Date(data.DueDate);
                var period = _.find($ctrl.allScheduledTasks,
                    function (row) {
                        return row.year === date.getFullYear() && row.month === date.getMonth();
                    });
                if (period) {
                    period.data = period.data || [];
                    period.data.push(ng.copy(data));
                }
                $ctrl.allScheduledTasks = ng.copy($ctrl.allScheduledTasks);
            });

        $rootScope.$on("scheduledTaskUpdated", function (result, data) {
            ng.forEach($ctrl.allScheduledTasks,
                function (row) {
                    var index = _.findIndex(row.data, function (d) { return d.Id === data.Id; });
                    if (index !== -1) {
                        row.data[index] = ng.copy(data);
                    }
                });
            $ctrl.allScheduledTasks = ng.copy($ctrl.allScheduledTasks);
        });

        $rootScope.$on("appointmentCreated",
            function (event, data) {
                var date = new Date(data.StartDate);
                var period = _.find($ctrl.allAppointments,
                    function (row) {
                        return row.year === date.getFullYear() && row.month === date.getMonth();
                    });
                data.StartDate = new Date(data.StartDate);
                data.EndDate = new Date(data.EndDate);
                data.AppointmentDetails = data.AppointmentDetails || [];
                if (period) {
                    period.data = period.data || [];
                    period.data.push(ng.copy(data));
                }
                $ctrl.allAppointments = ng.copy($ctrl.allAppointments);
            });

        $rootScope.$on("appointmentUpdated", function (result, data) {
            ng.forEach($ctrl.allAppointments,
                function (row) {
                    var index = _.findIndex(row.data, function (d) { return d.Id === data.Id; });
                    if (index !== -1) {
                        row.data[index] = ng.copy(data);
                    }
                });
            $ctrl.allAppointments = ng.copy($ctrl.allAppointments);
        });

        $rootScope.$on("scheduledTaskDeleted",
            function (result, data) {
                var date = new Date(data.DueDate);
                var period = _.find($ctrl.allScheduledTasks,
                    function (row) {
                        return row.year === date.getFullYear() && row.month === date.getMonth();
                    });
                if (period) {
                    var index = _.find(period.data,
                        function (row) {
                            return row.Id === data.Id;
                        });
                    if (index !== -1)
                        period.data.splice(index, 1);
                }
                $ctrl.allScheduledTasks = ng.copy($ctrl.allScheduledTasks);
            });

        $rootScope.$on("appointmentDeleted",
            function (result, data) {
                var date = new Date(data.StartDate);
                var period = _.find($ctrl.allAppointments,
                    function (row) {
                        return row.year === date.getFullYear() && row.month === date.getMonth();
                    });
                if (period) {
                    var index = _.find(period.data,
                        function (row) {
                            return row.Id === data.Id;
                        });
                    if (index !== -1)
                        period.data.splice(index, 1);
                }
                $ctrl.allAppointments = ng.copy($ctrl.allAppointments);
            });
    }
})(window.app, window.angular);
